/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRegionOverviewGet } from '../fn/region/api-region-overview-get';
import { ApiRegionOverviewGet$Params } from '../fn/region/api-region-overview-get';
import { RegionOverviewList } from '../models/region-overview-list';


/**
 * Region service
 */
@Injectable({ providedIn: 'root' })
export class RegionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRegionOverviewGet()` */
  static readonly ApiRegionOverviewGetPath = '/api/region/overview';

  /**
   * Get region overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRegionOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRegionOverviewGet$Response(params?: ApiRegionOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<RegionOverviewList>> {
    return apiRegionOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get region overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRegionOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRegionOverviewGet(params?: ApiRegionOverviewGet$Params, context?: HttpContext): Observable<RegionOverviewList> {
    return this.apiRegionOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegionOverviewList>): RegionOverviewList => r.body)
    );
  }

}
